export default __webpack_public_path__ + "dc-icon.png";